import axios from 'axios';
import { base_url } from '../config';

const api = axios.create({
  baseURL: base_url,
  timeout: 10000, // Set a reasonable timeout
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Log the error for debugging
    console.error('Request Interceptor Error:', error);
    
    // Show user-friendly message
    showToast('Network error occurred while setting up the request', 'error');
    
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    // You can add any response transformation here if needed
    return response;
  },
  async (error) => {
    
    if (error.response) {
      const { status, data } = error.response;
      
      // Handle specific status codes
      switch (status) {
        case 400:
          handleBadRequest(data);
          break;
          
        case 401:          
          handleUnauthorized();
          break;
          
        case 403:
          handleForbidden();
          break;
          
        case 404:
          handleNotFound();
          break;
          
        case 429:
          handleRateLimit();
          break;
          
        case 500:
          handleServerError();
          break;
          
        default:
          handleGenericError(status, data);
      }
    } else if (error.request) {
      // The request was made but no response was received
      handleNetworkError();
    } else {
      // Something happened in setting up the request
      handleRequestSetupError(error.message);
    }
    
    // Return a consistent error structure
    return Promise.reject(normalizeError(error));
  }
);

// Helper functions for error handling
function normalizeError(error) {
  return {
    message: error.response?.data?.message || error.message || 'An unknown error occurred',
    status: error.response?.status || 0,
    code: error.code,
    data: error.response?.data,
    isAxiosError: error.isAxiosError,
  };
}

// Error handlers (implement these according to your UI framework)
function showToast(message, type) {
  // Replace with your preferred notification system
  console[type](message);
}

function handleBadRequest(data) {
  const message = data.message || 'Invalid request data';
  showToast(message, 'error');
  // Optionally redirect or perform other actions
}

function handleUnauthorized() {
  showToast('Your session has expired. Please log in again.', 'error');
  localStorage.removeItem('token');
  // Redirect to login page
  window.location.href = '/login';
}

function handleForbidden() {
  showToast('You do not have permission to access this resource', 'error');
}

function handleNotFound() {
  showToast('The requested resource was not found', 'error');
}

function handleRateLimit() {
  showToast('Too many requests. Please try again later.', 'error');
}

function handleServerError() {
  showToast('Server error occurred. Please try again later.', 'error');
}

function handleNetworkError() {
  showToast('Network error. Please check your connection.', 'error');
}

function handleRequestSetupError(message) {
  showToast(`Request setup error: ${message}`, 'error');
}

function handleGenericError(status, data) {
  showToast(`Error ${status}: ${data.message || 'Unexpected error occurred'}`, 'error');
}

export default api;